import EventHook from './EventHook'

export default class StyleEventHook extends EventHook {
  constructor (name) {
    super('STYLE', name)
  }

  run (bid, slot, media) {
    return Promise.reject(Error('Override StartEventHook run()'))
  }
}
